// import { useEffect, useState } from "react";
// import VideoStatus from "./Video.status";
// import ViewImage from "./ViewImage";
// import ViewText from "./ViewText";

// interface Status {
//   type: "image" | "video" | "text";
//   // Add other status properties here
// }

// const ViewStatus = ({
//   userStatus,
//   close,
// }: {
//   userStatus: any;
//   close: () => void;
// }) => {
//   const [statusIndex, setStatusIndex] = useState(0);
//   const [progressStatus, setProgressStatus] = useState(0);

//   // Get current status based on index
//   const currentStatus = userStatus[statusIndex];
//   const type = currentStatus?.statusType;

//   useEffect(() => {
//     const intervalDuration = 3000;
//     if (statusIndex === userStatus?.length - 1) {
//       close();
//       return;
//     }

//     // Reset states when userStatus changes
//     setStatusIndex(0);
//     setProgressStatus(0);

//     const statusInterval = setInterval(() => {
//       setStatusIndex((prevIndex) => {
//         const nextIndex =
//           statusIndex === userStatus?.length ? 0 : prevIndex + 1;
//         return nextIndex;
//       });
//       setProgressStatus(0); // Reset progress when status changes
//     }, intervalDuration);

//     const progressInterval = setInterval(() => {
//       setProgressStatus((prev) =>
//         Math.min(prev + 100 / (intervalDuration / 100), 100)
//       );
//     }, 100);

//     return () => {
//       clearInterval(statusInterval);
//       clearInterval(progressInterval);
//     };
//   }, [userStatus]);

//   const renderStatus = () => {
//     if (!currentStatus) return null;
//     // console.log("return -->", currentStatus, "type -->", type);
//     switch (type) {
//       case "image":
//         return <ViewImage status={currentStatus} />;
//       case "video":
//         return <VideoStatus />;
//       case "text":
//         return <ViewText status={currentStatus} />;
//       default:
//         return <ViewText status={currentStatus} />;
//     }
//   };

//   return (
//     <div className="min-h-[300px] w-full">
//       {renderStatus()}
//       <div className="progress" style={{ width: `${progressStatus}%` }} />
//       <div className="progress-bar"></div>
//     </div>
//   );
// };

// export default ViewStatus;

// ----- version 2 -------
import { useEffect, useState } from "react";
import VideoStatus from "./Video.status";
import ViewImage from "./ViewImage";
import ViewText from "./ViewText";
import ViewVideo from "./ViewVideo";

interface Status {
  statusType: "image" | "video" | "text";
  // Add other properties like content, duration, etc.
}

interface ViewStatusProps {
  userStatus: Status[];
  close: () => void;
}

const ViewStatus = ({ userStatus, close }: ViewStatusProps) => {
  const [statusIndex, setStatusIndex] = useState(0);
  const [progressStatus, setProgressStatus] = useState(0);

  // Get current status based on index
  const currentStatus = userStatus[statusIndex];

  useEffect(() => {
    if (!userStatus.length) return;

    const intervalDuration = 3000; // 3 seconds per status
    let statusInterval: NodeJS.Timeout;
    let progressInterval: NodeJS.Timeout;

    const startProgress = () => {
      setProgressStatus(0);
      progressInterval = setInterval(() => {
        setProgressStatus((prev) =>
          Math.min(prev + 100 / (intervalDuration / 100), 100)
        );
      }, 100);
    };

    const changeStatus = () => {
      if (statusIndex >= userStatus.length - 1) {
        close();
      } else {
        setStatusIndex((prev) => prev + 1);
        startProgress();
      }
    };

    statusInterval = setTimeout(changeStatus, intervalDuration);
    startProgress();

    return () => {
      clearTimeout(statusInterval);
      clearInterval(progressInterval);
    };
  }, [statusIndex, userStatus, close]);

  const renderStatus = () => {
    if (!currentStatus) return null;
    switch (currentStatus.statusType) {
      case "image":
        return <ViewImage status={currentStatus} />;
      case "video":
        return <ViewVideo status={currentStatus} />;
      case "text":
        return <ViewText status={currentStatus} />;
      default:
        return <ViewText status={currentStatus} />;
    }
  };

  return (
    <div className="min-h-[300px] w-full">
      {renderStatus()}
      <div className="progress-container">
        <div className="progress-bar" style={{ width: `${progressStatus}%` }} />
      </div>
    </div>
  );
};

export default ViewStatus;
